(function () {
  "use strict";

  function addCustomButtons() {
    console.log("=== Running addCustomButtons ===");

    /* --------------------------------------------------
       1. REMOVE SHOPIFY QUICK ADD ICONS/BUTTONS COMPLETELY
    -------------------------------------------------- */
    document
      .querySelectorAll(
        ".quick-add, .quick-add__button, .product-card__quick-add, .card__badge-button, product-form1 button"
      )
      .forEach((btn) => {
        btn.style.display = "none";
      });

    /* --------------------------------------------------
       2. PROCESS EACH CARD
    -------------------------------------------------- */
    document.querySelectorAll(".card-wrapper").forEach(function (card, i) {
      if (card.dataset.customButtonAdded === "true") return;

      const cardContents = card.querySelectorAll(".card__content");
      if (!cardContents.length) return;

      const targetContent = cardContents[cardContents.length - 1];
      const productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) return;

      const productUrl = productLink.getAttribute("href");

      /* --------------------------------------------------
         FIND VARIANT ID (3 WAYS)
      -------------------------------------------------- */
      let variantId = null;

      const v1 = card.querySelector("input.product-variant-id");
      if (v1) variantId = v1.value;

      const v2 = card.querySelector('input[name="id"]');
      if (!variantId && v2) variantId = v2.value;

      const form = card.querySelector('form[action*="/cart/add"]');
      if (!variantId && form) {
        const inp = form.querySelector('input[name="id"]');
        if (inp) variantId = inp.value;
      }

      /* --------------------------------------------------
         3. CREATE BUTTON WRAPPER
      -------------------------------------------------- */
      const wrapper = document.createElement("div");
      wrapper.className = "custom-buttons-wrapper";
      wrapper.style.cssText =
        "margin-top: 12px; width: 100%; display: flex; gap: 8px; position: relative; z-index: 999;";

      // Make card allow overflow (so buttons not hidden)
      card.style.overflow = "visible";

      // ---------------- Add to Cart button ----------------
      const addToCartBtn = document.createElement("button");
      addToCartBtn.type = "button";
      addToCartBtn.className = "custom-add-to-cart-btn";
      addToCartBtn.textContent = "Add to Cart";
      addToCartBtn.style.cssText = `
        background: #725252;
        color: white;
        border: none;

        padding: 10px;
        font-size: 14px;
        font-weight: 500;
        width: 70%;
        min-height: 30px;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
        border-radius: 4px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        font-family:poppins !important;

        margin-bottom:40px;
      `;

      // Hover effect
      addToCartBtn.addEventListener("mouseenter", function () {
        if (!this.disabled) {
          this.style.background = "#5a4040";
          this.style.transform = "translateY(-2px)";
          this.style.boxShadow = "0 4px 12px rgba(0,0,0,0.25)";
        }
      });

      addToCartBtn.addEventListener("mouseleave", function () {
        if (!this.disabled) {
          this.style.background = "#725252";
          this.style.transform = "translateY(0)";
          this.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
        }
      });

      wrapper.appendChild(addToCartBtn);

      targetContent.style.display = "flex";
      targetContent.style.flexDirection = "column";

      targetContent.appendChild(wrapper);

      card.dataset.customButtonAdded = "true";

      /* --------------------------------------------------
         4. ADD-TO-CART FUNCTION
      -------------------------------------------------- */
      addToCartBtn.addEventListener("click", async function (e) {
        e.preventDefault();
        e.stopPropagation();

        let finalVariantId = variantId;

        if (!finalVariantId) {
          addToCartBtn.textContent = "Loading...";
          try {
            const handle = productUrl.split("/products/")[1].split("?")[0];
            const response = await fetch(`/products/${handle}.js`);
            const productData = await response.json();

            finalVariantId =
              productData.variants.find((v) => v.available)?.id ||
              productData.variants[0]?.id;
          } catch (err) {
            window.location.href = productUrl;
            return;
          }
        }

        addToCartBtn.disabled = true;
        addToCartBtn.textContent = "Adding...";
        addToCartBtn.style.cursor = "not-allowed";
        addToCartBtn.style.opacity = "0.7";

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              id: finalVariantId,
              quantity: 1,
            }),
          });

          const result = await response.json();
          if (!response.ok) throw result;

          addToCartBtn.textContent = "✓ Added to Cart!";
          addToCartBtn.style.background = "#28a745";
          addToCartBtn.style.cursor = "default";

          /* --------------------------------------------------
             UPDATE CART DRAWER WITH FRESH DATA
          -------------------------------------------------- */
          try {
            // Fetch updated cart data
            const cartData = await fetch("/cart.js").then((r) => r.json());
            updateCartCount(cartData.item_count);

            // Fetch fresh cart drawer HTML from Shopify
            const sectionsToUpdate = ["cart-drawer", "cart-icon-bubble"];
            const sectionsUrl = window.location.origin + `/?sections=${sectionsToUpdate.join(",")}`;
            const sectionsResponse = await fetch(sectionsUrl);
            const sectionsData = await sectionsResponse.json();

            // Update cart drawer content
            const drawer = document.querySelector("cart-drawer");
            if (drawer && sectionsData["cart-drawer"]) {
              // Parse the new HTML
              const parser = new DOMParser();
              const newDoc = parser.parseFromString(sectionsData["cart-drawer"], "text/html");
              const newDrawerContent = newDoc.querySelector("cart-drawer");
              
              if (newDrawerContent) {
                // Replace entire drawer element to ensure all content updates
                drawer.replaceWith(newDrawerContent);
              }
            }

            // Update cart icon bubble
            if (sectionsData["cart-icon-bubble"]) {
              const cartBubble = document.querySelector("#cart-icon-bubble");
              if (cartBubble) {
                const parser = new DOMParser();
                const bubbleDoc = parser.parseFromString(sectionsData["cart-icon-bubble"], "text/html");
                const newBubble = bubbleDoc.querySelector("#cart-icon-bubble");
                if (newBubble) {
                  cartBubble.replaceWith(newBubble);
                }
              }
            }

            // Open the refreshed drawer
            setTimeout(() => {
              const updatedDrawer = document.querySelector("cart-drawer");
              
              if (updatedDrawer) {
                // Open the drawer
                if (typeof updatedDrawer.open === "function") {
                  updatedDrawer.open();
                } else {
                  updatedDrawer.setAttribute("open", "true");
                  updatedDrawer.classList.add("active", "animate");
                }
              }
            }, 200);

          } catch (error) {
            console.error("Cart update error:", error);
            // Fallback: reload page to show cart
            window.location.reload();
          }

          // Reset button after 2 seconds
          setTimeout(() => {
            addToCartBtn.textContent = "Add to Cart";
            addToCartBtn.style.background = "#725252";
            addToCartBtn.style.cursor = "pointer";
            addToCartBtn.style.opacity = "1";
            addToCartBtn.disabled = false;
          }, 2000);
        } catch (error) {
          console.error("Add to cart error:", error);
          addToCartBtn.textContent = "Error - Try Again";
          addToCartBtn.style.background = "#dc3545";
          addToCartBtn.disabled = false;
          addToCartBtn.style.cursor = "pointer";
          addToCartBtn.style.opacity = "1";

          setTimeout(() => {
            addToCartBtn.textContent = "Add to Cart";
            addToCartBtn.style.background = "#725252";
          }, 2000);
        }
      });
    });
  }

  /* --------------------------------------------------
     UPDATE CART QUANTITY
  -------------------------------------------------- */
  function updateCartCount(count) {
    document
      .querySelectorAll(
        ".cart-count, .cart-count-bubble, [data-cart-count], .cart-count__bubble, #cart-icon-bubble, .header__icon--cart .count"
      )
      .forEach((el) => {
        el.textContent = count;
        el.style.display = count > 0 ? "" : "none";
      });
  }

  // Run script
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", addCustomButtons);
  } else {
    addCustomButtons();
  }

  setTimeout(addCustomButtons, 1000);
  setTimeout(addCustomButtons, 2000);

  new MutationObserver(() => addCustomButtons()).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();